var map = {
	"./app-empty-state.png": "d898",
	"./app-mockup-v2.png": "6236",
	"./app-mockup.png": "7679",
	"./coins-instructions-illustration.svg": "cc0a",
	"./coins.svg": "8094",
	"./customer-perspective.png": "693c",
	"./share-blue.svg": "fdcc",
	"./tab-background-left-v2.svg": "3d7d",
	"./tab-background-left.svg": "3c2b",
	"./tab-background-right-v2.svg": "da832",
	"./tab-background-right.svg": "fbff",
	"./widget-coupon-mockup.svg": "c161",
	"./widget-empty-state.png": "ab11",
	"./widget-mockup-v2.png": "427d",
	"./widget-mockup.png": "c3b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ce3";